<template>
  <div class="about-section" id="about-section">
    <!-- About me -->
    <div class="mcf-about">
      <div class="auth-pic-cont">
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>
        <span class="span-particle"></span>

        <div class="auth-pic-cont">
          <img class="author-pic" src="../assets/images/auth-img.png" />
        </div>
      </div>

      <div class="author-info-cont">
        <h2 class="text-center">Michael McFarland</h2>
        <h4 class="text-shadow-3 text-center">Full Stack Web Developer</h4>
        <v-row justify="space-around">
          <span class="mcf-icon-links group pa-5">
            <a
              href="https://www.linkedin.com/in/michael-d-mcfarland/"
              target="_blank"
              ><v-icon x-large>mdi-linkedin</v-icon></a
            >
            <a href="https://github.com/mcfarlandweb/" target="_blank"
              ><v-icon x-large>mdi-github</v-icon></a
            >
            <a href="https://www.instagram.com/mcfarland422/" target="_blank"
              ><v-icon x-large>mdi-instagram</v-icon></a
            >
            <a href="https://twitter.com/mcfarland422" target="_blank"
              ><v-icon x-large>mdi-twitter</v-icon></a
            >
            <a
              href="http://www.imdb.com/name/nm5467446/?ref_=fn_al_nm_1"
              target="_blank"
              ><v-icon x-large>mdi-movie-open</v-icon></a
            >
          </span>
        </v-row>
      </div>

      <Terminal />

      <div class="section-header">
        <h2>About Me</h2>
      </div>

      <div class="about-story-cont">
        <div class="row">
          <div class="ga-southern about-story-box-img">
            <img class="" src="../assets/images/ga-southern.jpeg" />
          </div>
          <div class="about-story-box-text about-story-box-1">
            <p>
              With a Bachelor of Science in Multimedia Communications, from
              <v-tooltip top>
                <template v-slot:activator="{ on, hailsouthern }">
                  <span class="hail-southern" v-bind="hailsouthern" v-on="on">
                    Georgia Southern University
                  </span>
                </template>
                <span class="southern-span">Hail Southern!</span> </v-tooltip
              >, I immediately started working in the Film Industry. Producing
              my own video projects, working with camera/lighting departments
              for movies, commercials & music videos, gave me an extensive
              background in video production. I’ve gained a strong understanding
              of how to use design to communicate effectively and ultimately
              tell a great story. These skills prove invaluable in running a
              freelance business.
            </p>
          </div>
        </div>

        <div class="row second-row">
          <div class="about-story-box-text about-story-box-2">
            <p>
              Coding started out as a hobby that was self-taught in my free
              time. The more I learned, the greater my desire to know more
              increased. Before long, I was hooked & stared making websites for
              friends. Gaining paying web clients, evolved into a side business.
              Deciding to push myself further and take a deep dive into web
              development, I searched for training opportunities. In September
              of 2017, I joined
              <span class="dig-crafts">DigitalCrafts</span>, a Full Stack
              Immersive boot camp. It’s designed to transform beginner builders
              into full-stack software engineers. DigitalCrafts offered a whole
              new arsenal of development skills. These new skills give me the
              tools to create amazing websites & applications.
            </p>
          </div>
          <div class="dig-crafts-img about-story-box-img">
            <img class="" src="../assets/images/digitalcrafts.png" />
          </div>
        </div>
        <div class="problem-solve-box">
          <p>
            Problem solving is central to everything. I care deeply about
            creating unique, useful and beautiful products that help people and
            make a difference. I like to be involved at different stages of a
            digital project, from the concept, to sketches, design and of
            course, the front-end build. <br /><br />Learn more about all the
            creative talents and solutions that I can provide to your project.
            My portfolio is below. Feel free to <a href="#">contact me</a> with
            any questions or special requests.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Terminal from "../components/Terminal";

export default {
  components: {
    Terminal,
  },
};
</script>

<style lang="scss">
@import "../scss/styles.scss";
@import url("https://fonts.googleapis.com/css?family=Gloria+Hallelujah");
.mcf-about {
  margin-top: 5rem;
  .section-header {
    h2 {
      color: $mcf-blue;
      font-size: 3rem;
      @include mobile-down {
        padding: 1rem 0;
      }
      @include md {
        padding-bottom: 2rem;
      }
    }
  }
}

.about-story-cont {
  max-width: 1210px;
  margin: auto;
  padding: 0 1rem 4rem;
  @include md {
    padding: 0 1rem 6rem;
  }
  p {
    font-family: "Gloria Hallelujah";
    font-size: 1.2rem;
    @include mobile-down {
      text-align: center;
    }
    @include md {
      font-size: 1.5rem;
    }
  }
  .row {
    align-items: center;
    margin: 0.2rem 0;

    @include md {
      margin: 2rem 0;
    }
  }
  .second-row {
    @include mobile-down {
      flex-direction: column-reverse;
    }
  }
  .ga-southern {
    img {
      width: 100%;
    }
    @include mobile-down {
      margin-bottom: 1.2rem;
    }
    @include sm {
      display: inline-block;
      width: 50%;
      padding-right: 2rem;
    }
  }
  .dig-crafts-img {
    img {
      width: 100%;
    }
    @include mobile-down {
      margin: 1.2rem 0;
    }
    @include sm {
      display: inline-block;
      width: 50%;
      padding-left: 2rem;
    }
  }
  .about-story-box-text {
    @include sm {
      display: inline-block;
      width: 60%;
    }
  }
  .about-story-box-img {
    @include sm {
      display: inline-block;
      width: 40%;
    }
  }
  .about-story-box-1 {
    @include md {
      padding-left: 1rem;
    }
  }
  .hail-southern,
  .dig-crafts {
    display: inline-block;
    color: $mcf-blue;
    font-weight: 600;
  }
  a {
    text-decoration: none;
    color: $mcf-blue;
    font-weight: 600;
  }
}
.v-tooltip__content {
  font-size: 2rem !important;
  padding: 2rem !important;
  line-height: 1.5 !important;
  @include md {
    font-size: 3rem !important;
    padding: 2rem !important;
    line-height: 1.5 !important;
  }
}

// bg particle settings
$particleSize: 20vmin;
$animationDuration: 6s;
$amount: 20;

.auth-pic-cont {
  border-radius: 100%;
  margin: 2rem auto;
  overflow: hidden;
  width: 80%;
  max-width: 450px;

  background: #09264b;
  position: relative;

  span.span-particle {
    width: $particleSize;
    height: $particleSize;
    border-radius: $particleSize;
    backface-visibility: hidden;
    -webkit-backface-visibility: hidden;
    position: absolute;
    animation-name: move;
    animation-duration: $animationDuration;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    $colors: (#ccc, $mcf-blue, #aed6ff);
    @for $i from 1 through $amount {
      &:nth-child(#{$i}) {
        color: nth($colors, random(length($colors)));
        top: random(100) * 1%;
        left: random(100) * 1%;
        animation-duration: (random($animationDuration * 10) / 10) * 1s + 10s;
        animation-delay: random(($animationDuration + 10s) * 10) / 10 * -1s;
        transform-origin: (random(50) - 25) * 1vw (random(50) - 25) * 1vh;
        $blurRadius: (random() + 0.5) * $particleSize * 0.5;
        $x: if(random() > 0.5, -1, 1);
        box-shadow: ($particleSize * 2 * $x) 0 $blurRadius currentColor;
      }
    }
  }
}

@keyframes move {
  100% {
    transform: translate3d(0, 0, 1px) rotate(360deg);
  }
}

.author-pic {
  width: 100%;
}
.mcf-about {
  .author-info-cont {
    padding: 0 1.5rem 2rem;
  }
  h2,
  h4 {
    line-height: 1.3;
  }
  h2 {
    font-family: "Montserrat", sans-serif;
  }
  h4 {
    color: $mcf-blue;
    font-size: 1.6rem;
  }

  .author-desc {
    p {
      margin: 0.6rem 0 1.8rem;
    }
  }

  .mcf-icon-links {
    a {
      padding: 0 4px;
      text-decoration: none;
      &:hover .v-icon {
        color: $mcf-blue !important;
        font-size: 44px !important;
      }
    }
  }
}
</style>